export const surveyButtonDestinations = [
  { label: "Home Screen", value: "flashhealthapp://homeScreen" },
  { label: "Wallet", value: "flashhealthapp://myEarnings?showHeader=true" },
  { label: "Create Medicine Order", value: "flashhealthapp://createOrder?orderType=Medicine" },
  { label: "Create Lab Order", value: "flashhealthapp://createOrder?orderType=Lab" },
  { label: "Talk Now Consultation", value: "flashhealthapp://firstAdvice?consultType=TalkNow" },
  { label: "Talk Later Consultation", value: "flashhealthapp://firstAdvice?consultType=TalkLater" },
];

export const defaultSurveyButtonConfig = {
  label: "Return to Home",
  deepLinkUrl: "flashhealthapp://homeScreen",
};

export const surveyTargetingStrategies = [
  {
    value: 1,
    label: "No active or completed medicine, lab, or consultation orders",
    description: "Targets leads without active or completed medicine, laboratory, or consultation orders.",
  },
  {
    value: 2,
    label: "Exactly one completed medicine, lab, or consultation order",
    description: "Targets leads with exactly one completed order across medicine, laboratory, and consultation services.",
  },
];

export const questionTypeLabels = {
  single_choice: "Single choice",
  multi_choice: "Multiple choice",
  text: "Text",
  number: "Number",
  rating: "Rating",
};
